<template>
	<div>
		<div class="container table-actions steps">
			<button
				v-if="USER.username === '950302350184'"
				@click="decideProblem()"
				class="table-actions-button btn-green"
			>
				Решить проблемы
			</button>
			<div v-if="isImpl">
				<button
					v-if="!TMZREPORT.withDigitalSign && TMZREPORT.step === 6 || TMZREPORT.status === 'Разрешена корректировка'"
					v-show="createAllowed"
					class="table-actions-button btn-green"
					@click="openModalECP"
					type="button"
				>
					Подписать и отправить
				</button>
				<button
					v-if="
						TMZREPORT.status === 'Создан' ||
							TMZREPORT.status === 'Редактирован' ||
							TMZREPORT.status === 'Ошибка' ||
							TMZREPORT.status === 'Ошибка_минус' ||
							TMZREPORT.status === 'Ошибка_в_утвержденном_бюджет' ||
							TMZREPORT.status === 'Ошибка в аварийных запасах' ||
							TMZREPORT.status === 'Отклонен утверждающим' ||
							TMZREPORT.status === 'Разрешена корректировка'
					"
					class="table-actions-button btn-red"
					type="button"
					@click="rmReport()"
				>
					Удалить отчёт
				</button>
				<button
					v-if="TMZREPORT.status === 'Подписан утверждающим'"
					class="table-actions-button btn-blue"
					type="button"
					@click="openModalEditApprovedReport()"
				>
					Запрос на редактирование
				</button>
				<button
						v-if="!createAllowed && TMZREPORT.step === 6 && TMZREPORT.status === 'Создан' || TMZREPORT.status === 'Подписан исполнителем'"
						type="button"
						class="table-actions-button btn-green"
						@click="openModalEditApprovedReport()"
					>
						Запрос на сдачу отчётности
					</button>
			</div>
			<div v-if="isApproved">
				<div
					v-if="
						TMZREPORT.withDigitalSign &&
							TMZREPORT.status === 'Подписан исполнителем'
					"
				>
					<button
						type="button"
						class="table-actions-button btn-green"
						@click="openModalECP"
					>
						Утвердить и отправить в КМГ
					</button>
					<button
						type="button"
						class="table-actions-button btn-red"
						@click="openModalRejectDzo()"
					>
						Отклонить
					</button>
				</div>
			</div>
			<div v-if="isRecipient">
				<div
					v-if="
						// TMZREPORT.withDigitalSign &&
							TMZREPORT.status === 'Запрос на корректировку'
					"
				>
					<button
						type="button"
						class="table-actions-button btn-green"
						@click="openModalEditRequest()"
					>
						Запрос на корректировку
					</button>

				</div>
			</div>
			<div>
<!--					<button-->
<!--						v-if="TMZREPORT.status === 'Разрешена корректировка' && !isImpl"-->
<!--						type="button"-->
<!--						class="table-actions-button btn-green"-->
<!--						@click="openModalECP"-->
<!--					>-->
<!--						Утвердить и отправить в КМГ-->
<!--					</button>-->
				<button
					class="table-actions-button btn-green"
					v-if="TMZREPORT.withDigitalSign"
					@click="openModalApprovedPersons"
				>
					Утвердившие
				</button>
				<button
					v-if="TMZREPORT.step === 6"
					class="table-actions-button btn-fio"
					@click="openModalHistory"
				>
					История
				</button>
				<button
					v-if="TMZREPORT.step >= 1"
					class="table-actions-button btn-yellow"
					@click="downLoadExcel()"
				>
          Скачать отчет в Excel
				</button>
				<button
					v-if="
						TMZREPORT.status === 'Ошибка' ||
						TMZREPORT.status === 'Ошибка в аварийных запасах' ||
							TMZREPORT.status === 'Ошибка_минус' ||
							TMZREPORT.status === 'Ошибка_в_утвержденном_бюджет'
					"
					class="table-actions-button btn-red"
					@click="toError()"
				>
					Ошибки в файле
				</button>

			</div>

			<section class="auth-modal">
				<!-- Modal Content Wrapper -->
				<div id="auth-modal-content" class="auth-modal-content">
					<div class="modal-info">
						<div
							class="modal-info-inner"
							:class="{ modalInfoEcp: showModalEcp === true }"
						>
							<div v-if="showModalEcp">
								<h3>Подписать через ЭЦП</h3>
								<form
									method="POST"
									id="auth-form"
									@submit.prevent="sendSignXml"
								>
									<div hidden>
										<select id="storageSelect">
											<option value="PKCS12" selected>
												PKCS12
											</option>
										</select>
									</div>

									<p class="auth-moda-explanations">
										Для успешной подписи рекомендуется
										<br />
										выбирать ключ
										<b>GOSTKNCA</b>
									</p>

									<textarea
										hidden
										id="xmlToSign"
										name="xmlToSign"
										v-model="xmlToSignPro"
										rows="6"
									></textarea>
									<textarea
										hidden
										class="form-control"
										id="signedXml"
										name="signedXml"
										rows="6"
										readonly
									></textarea>
									<button
										class="auth-choose-cert"
										type="button"
										@click="signXmlCall"
									>
										Выбрать сертификат
									</button>
									<button id="test" type="submit" hidden>
										submit
									</button>
								</form>
							</div>
							<div v-else-if="showModalHistory">
								<div
									class="history-container"
									v-if="
										historyTmzReports &&
											historyTmzReports.length > 0
									"
								>
									<h2>История отчета</h2>
									<table class="history-table">
										<thead>
											<tr>
												<th>Номер</th>
												<th>Ф.И.О.</th>
												<th>Статус до</th>
												<th>Статус после</th>
												<th>Файл</th>
											</tr>
										</thead>
										<tbody>
											<tr></tr>
											<tr
												v-for="historyTmzReport in historyTmzReports"
												:key="historyTmzReport.id"
												class="history"
											>
												<td>
													{{
														historyTmzReport.number
													}}
												</td>
												<td>
													{{
														historyTmzReport
															.action_user
															.last_name
													}}
													{{
														historyTmzReport
															.action_user
															.first_name
													}}
												</td>
												<td>
													{{
														historyTmzReport.status_before
													}}
												</td>
												<td>
													{{
														historyTmzReport.status_after
													}}
													<span
														v-if="
															historyTmzReport.reject_reason
														"
													>
														.Причина:
														{{
															historyTmzReport.reject_reason
														}}
													</span>
												</td>
												<td v-if="historyTmzReport.edit_file"><a class="link-file" :href="historyTmzReport.edit_file" target="_blank">Скачать</a></td>
											</tr>
										</tbody>
									</table>
								</div>
							</div>
							<div
								class="reject-block"
								v-else-if="showModalRejectDzo"
							>
								<h4>Причина отклонения</h4>
								<textarea v-model="reason" required></textarea>
								<button
									type="button"
									@click="rejectTmzReportDzo"
									class="table-actions-button btn-red"
								>
									Отклонить
								</button>
							</div>
							<div v-else-if="showModalApprovedPersons">
								<div
									class="history-container"
									v-if="TMZREPORT.withDigitalSign"
								>
									<h2>Утвердившие посредством ЭЦП</h2>
									<table class="history-table">
										<thead>
											<tr>
												<th>Ф.И.О.</th>
												<th>Время подписи</th>
											</tr>
										</thead>
										<tbody>
											<tr></tr>
											<tr
												v-for="signLevel in TMZREPORT.tmz_report_sign_level"
												:key="signLevel.id"
												class="history"
											>
												<td>
													{{
														signLevel.sign_user
															.last_name
													}}
													{{
														signLevel.sign_user
															.first_name
													}}
												</td>
												<td>
													{{
														signLevel.sign_date
															| formatDate
													}}
												</td>
											</tr>
										</tbody>
									</table>
								</div>
							</div>
							<div v-else-if="showModalEditApprovedReport">
								<div class="edit-approved-report-modal">
									<h2>
										Для формирования запроса на
										редактирование загрузите скан письма в
										АО "НК "КазМунайГаз" на имя директора
										департамента закупок и снабжения
									</h2>
									<button
										class="uploadScannedDocument"
										type="submit"
									>
										<div class="file-area">
											<input
												type="file"
												name="file"
												ref="file"
												id="file"
												@change="inputChanged()"
											/>
											<div class="file-state">
												<div class="success">
													Отлично, файл был загружен
												</div>
												<div class="default">
													Загрузить отсканированный
													документ
												</div>
											</div>
										</div>
									</button>
									<button
										class="w-6/12 block flex sm:inline-flex justify-center items-center transition-all py-4 ease-in-out duration-150 transform hover:scale-110 bg-blue-500 hover:bg-blue-600 px-10 rounded-lg text-white"
										@click="submitFile()"
									>
										Отправить
									</button>
								</div>
							</div>
							<div class="modalEditRequest" v-else-if="showModalEditRequest">

								<div>
									<button
									type="button"
									class="table-actions-button btn-green"
									@click="rejectTmzReport()"
									>
										Разрешаю редактирование
									</button>
									<button
										type="button"
										class="table-actions-button btn-red"
										@click="rejectTmzAdjustment()"
									>
										Отклонить корректировку
									</button>
									<button
										type="button"
										class="table-actions-button btn-yellow"
										@click="toggleFilePreview()">
										Посмотреть файл
									</button>
								</div>

								<embed
									v-if="showFile"
									class="embed-file"
									:src="file_url"
									type=""
								/>
							</div>
						</div>
					</div>

					<a href="#" class="close-auth-modal" @click="closeModal">
						<!-- X close auth icon -->
						<svg
							version="1.1"
							xmlns="http://www.w3.org/2000/svg"
							xmlns:xlink="http://www.w3.org/1999/xlink"
							x="0"
							y="0"
							viewBox="0 0 32 32"
							style="enable-background: new 0 0 32 32"
							xml:space="preserve"
							width="24"
							height="24"
						>
							<g id="icon-x-close">
								<path
									fill="#ffffff"
									d="M30.3448276,31.4576271 C29.9059965,31.4572473 29.4852797,31.2855701 29.1751724,30.980339 L0.485517241,2.77694915 C-0.122171278,2.13584324 -0.104240278,1.13679247 0.52607603,0.517159487 C1.15639234,-0.102473494 2.17266813,-0.120100579 2.82482759,0.477288136 L31.5144828,28.680678 C31.9872448,29.1460053 32.1285698,29.8453523 31.8726333,30.4529866 C31.6166968,31.0606209 31.0138299,31.4570487 30.3448276,31.4576271 Z"
									id="Shape"
								></path>
								<path
									fill="#ffffff"
									d="M1.65517241,31.4576271 C0.986170142,31.4570487 0.383303157,31.0606209 0.127366673,30.4529866 C-0.12856981,29.8453523 0.0127551942,29.1460053 0.485517241,28.680678 L29.1751724,0.477288136 C29.8273319,-0.120100579 30.8436077,-0.102473494 31.473924,0.517159487 C32.1042403,1.13679247 32.1221713,2.13584324 31.5144828,2.77694915 L2.82482759,30.980339 C2.51472031,31.2855701 2.09400353,31.4572473 1.65517241,31.4576271 Z"
									id="Shape"
								></path>
							</g>
						</svg>
					</a>
				</div>
				<!-- end modal content wrapper -->

				<!-- clickable overlay element -->
				<div class="overlay" @click="closeModal"></div>
			</section>
		</div>
	</div>
</template>

<script>
import { signXml } from '@/nclayer/ncalayer';
import { isApproved, isImpl, isRecipient } from '@/variables';
import { mapGetters } from 'vuex';
import { router } from '@/router';

export default {
	name: 'EcpSign',
	data() {
		return {
			showFile: false,
			file_url: '',
			historyTmzReports: '',
			xmlToSign: '',
			showModalEcp: false,
			showModalEcpList: false,
			showModalHistory: false,
			showModalApprovedPersons: false,
			showModalEditApprovedReport: false,
			showModalEditRequest: false,
			showModalRejectDzo: false,
			isApproved: false,
			isImpl: false,
			isRecipient: false,
			reason: '',
		};
	},
	props: ['xmlToSignPro', 'tmzId'],
	methods: {
		sendSignXml() {
			let signedXml = document.getElementById('signedXml');
			let formData = {
				signedXml: signedXml.value,
				reportId: this.tmzId,
			};
			this.$store
				.dispatch('sendSignXmlTmz', formData)
				.then(() => {
					location.reload();
					this.$store.dispatch('addNotification', {
						type: 'success',
						message: 'Отчет подписан',
					});
				})
				.catch(error => {
					this.closeModal();
					this.$store.dispatch('addNotification', {
						type: 'error',
						message: 'Отчет не подписан - ' + error.response.data,
					});
				});
		},
		signXmlCall() {
			let selectedStorage = 'PKCS12';
			this.xmlToSign = this.xmlToSignPro;
			//this.xmlToSign = '';
			signXml(selectedStorage, 'SIGNATURE', this.xmlToSign);
		},
		openModalECP() {
			this.showModalEcp = true;

			let body = document.body;
			body.classList.add('show-auth-modal', 'noscroll');

			// Close modal if ESC key tapped
			body.addEventListener('keyup', e => {
				if (e.keyCode == 27) {
					this.closeModal();
				}
			});
		},
		openModalHistory() {
			this.showModalHistory = true;
			let body = document.body;
			body.classList.add('show-auth-modal', 'noscroll');

			// Close modal if ESC key tapped
			body.addEventListener('keyup', e => {
				if (e.keyCode == 27) {
					this.closeModal();
				}
			});
		},
		openModalRejectDzo() {
			this.showModalRejectDzo = true;
			let body = document.body;
			body.classList.add('show-auth-modal', 'noscroll');

			// Close modal if ESC key tapped
			body.addEventListener('keyup', e => {
				if (e.keyCode == 27) {
					this.closeModal();
				}
			});
		},
		openModalApprovedPersons() {
			this.showModalApprovedPersons = true;
			let body = document.body;
			body.classList.add('show-auth-modal', 'noscroll');

			// Close modal if ESC key tapped
			body.addEventListener('keyup', e => {
				if (e.keyCode == 27) {
					this.closeModal();
				}
			});
		},
		openModalEditApprovedReport() {
			this.showModalEditApprovedReport = true;
			let body = document.body;
			body.classList.add('show-auth-modal', 'noscroll');

			// Close modal if ESC key tapped
			body.addEventListener('keyup', e => {
				if (e.keyCode == 27) {
					this.closeModal();
				}
			});
		},
		openModalEditRequest() {
			this.showModalEditRequest = true;
			let body = document.body;
			body.classList.add('show-auth-modal', 'noscroll');

			// Close modal if ESC key tapped
			body.addEventListener('keyup', e => {
				if (e.keyCode == 27) {
					this.closeModal();
				}
			});
		},
		closeModal() {
			this.showModal = false;
			this.showModalEcp = false;
			this.showModalEcpList = false;
			this.showModalHistory = false;
			this.showModalApprovedPersons = false;
			this.showModalEditApprovedReport = false;
			this.showModalEditRequest = false;
			let body = document.body;
			body.classList.remove('show-auth-modal', 'noscroll');
		},
		rmReport() {
			this.$store.dispatch('rmTmzReport', this.$route.params.id);
		},
		decideProblem() {
			this.$store.dispatch('decideProblem');
		},
		getTmzHistory() {
			this.$store
				.dispatch('getTmzHistory', this.$route.params.id)
				.then(data => {
					this.historyTmzReports = data;
				});
		},
		rejectTmzReportDzo() {
			let formData = {
				reportId: this.$route.params.id,
				reason: this.reason,
			};
			this.$store.dispatch('rejectTmzReportDzo', formData);
		},
		rejectTmzReport() {
			let formData = {
				reportId: this.$route.params.id,
			};
			this.$store.dispatch('rejectTmzReport', formData);
			this.closeModal();
		},
		rejectTmzAdjustment() {
			let formData = {
				reportId: this.$route.params.id,
			};
			this.$store.dispatch('rejectTmzAdjustment', formData);
		},
		toggleFilePreview() {
			this.showFile = !this.showFile
		},
		inputChanged() {
			const file = document.querySelector('#file'),
				defaultDiv = document.querySelector('.default'),
				successDiv = document.querySelector('.success'),
				parentStateElement = successDiv.parentElement,
				greenBackground = '#36B300';

			let fileName = file.value,
				idxDot = fileName.lastIndexOf('.') + 1,
				extFile = fileName
					.substr(idxDot, fileName.length)
					.toLowerCase();
			if (
				!(
					extFile == 'png' ||
					extFile == 'jpeg' ||
					extFile == 'jpg' ||
					extFile == 'pdf'
				)
			) {
				alert('Следует загружать следующие типы файлов: xlsx, xls');
				file.value = '';
			} else {
				defaultDiv.style.display = 'none';
				successDiv.style.display = 'inline-block';
				parentStateElement.style.backgroundColor = greenBackground;
			}
		},
		submitFile() {
			this.file = this.$refs.file.files[0];

			let formData = new FormData();
			if (this.file) {
				formData.append('file', this.file);
				formData.append('tmz_report_id', this.TMZREPORT.id);
				this.$store.dispatch('sendTmzEditFile', formData);
			}
		},
		getTmzReport() {
			this.$store
				.dispatch('getTmzReport', this.$route.params.id)
				.then(data => {
					if (data.tmz_files && data.tmz_files.length > 0) {
						this.file_url = data.tmz_files[data.tmz_files.length - 1].file_data;
					}
				});
		},
		downLoadExcel() {
			let formData = {
				reportId: this.$route.params.id,
				month: '',
			};
			this.$store.dispatch('downLoadTmzExcel', formData);
		},
		toError() {
			router.push({
				name: 'tmz-error',
				params: { id: this.$route.params.id },
			});
		},
	},
	mounted() {
		this.getTmzReport();
		this.getTmzHistory();
		this.isApproved = isApproved(this.USER.ouser);
		this.isImpl = isImpl(this.USER.ouser);
		this.isRecipient = isRecipient(this.USER.ouser);
	},
	computed: {
		...mapGetters(['REPORT', 'USER', 'TMZREPORT', 'createAllowed']),
	},
};
</script>

<style scoped>
.steps {
	padding-top: 2rem;
}
.table-container {
	/* overflow-x: auto; */
	/* padding: 0 2rem; */
	min-width: 1800px;
	margin: 0 auto;
}

.table-container-inner {
	padding: 0.5rem;
	margin: 0 2rem;
	/* padding: 1rem 2rem; */
	/* margin-right: 2rem; */
	/* margin: 1rem 2rem; */
	overflow-x: auto;
	max-width: 100vw;
}

table {
	width: 100%;
	border-collapse: collapse;
	text-align: center;
	margin: 0 auto 2rem;
	overflow-x: auto;
	border-bottom: 1px solid black;
}

.table-naming {
	font-size: 2rem;
	font-weight: bold;
	padding: 1rem 0;
	text-align: left;
}

.table-status {
	margin-bottom: 0.5rem;
}

th,
td {
	border: 1px solid #868686;
	padding: 0 1rem;
}

.expanded {
	padding: 0 2rem;
}

.table-specs {
	background: #36429e;
	width: 100px;
	height: 100px;
	color: white;
	text-align: center;
	border-top-left-radius: 10px;
	border: none;
	font-size: 1.5rem;
	vertical-align: bottom;
}

.table-actions {
	display: flex;
	/* padding: 2rem 0; */
	justify-content: center;
}

.table-actions-button {
	padding: 1rem 2rem;
	border: none;
	outline: none;
	border-radius: 10px;
	margin-left: 1rem;
	cursor: pointer;
	font-size: 1.1rem;
}

.btn-green {
	background: #7ad38d;
	color: white;
}

.btn-yellow {
	background: #ffbb56;
	color: white;
}

.btn-red {
	background: #e86363;
	color: white;
}

.btn-fio {
	background: #6c63e8;
	color: white;
}

/* auth Modal
-----------------------------------------*/
.auth-modal,
.auth-modal .overlay {
	position: absolute;
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;
	z-index: 3000;
}

.auth-modal {
	overflow: hidden;
	position: fixed;
	opacity: 0;

	-webkit-transform: translate(500%, 0%);
	transform: translate(500%, 0%);

	-webkit-transition: -webkit-transform 0s linear 0s;
	transition: transform 0s linear 0s;

	/* using flexbox for vertical centering */

	/* Flexbox display */
	display: -webkit-box;
	display: -webkit-flex;
	display: flex;

	/* Vertical alignment */
	-webkit-box-align: center;
	-moz-box-align: center;
	-ms-flex-align: center;
	-webkit-align-items: center;
	align-items: center;

	-webkit-transform-style: preserve-3d;
	-moz-transform-style: preserve-3d;
	transform-style: preserve-3d;
}

.auth-modal .overlay {
	z-index: 0;
	background: rgba(13, 1, 61, 0.82);
	/* overlay color */

	opacity: 0;

	-webkit-transition: opacity 0.2s ease-out 0.05s;
	transition: opacity 0.2s ease-out 0.05s;
}

.auth-modal-content {
	position: relative;
	top: auto;
	right: auto;
	bottom: auto;
	left: auto;
	z-index: 1;

	margin: 0 auto;

	overflow-y: visible;

	background: #000;

	width: calc(100% - 12em);
	height: 0;
	padding-top: calc((100% - 12em) * 0.5625);
	/* 16:9 calc */
}

/* Scaling to fit within the current Viewport size:
   When viewport aspect ratio is greater than 16:9
   work off the height instead of the width for calc */
@media (min-aspect-ratio: 16/9) {
	.auth-modal-content {
		width: 0;
		height: calc(100vh - 10em);
		padding-top: 0;
		padding-left: calc((100vh - 10em) * 1.7778);
		/* 16:9 calc */
	}
}

/* Mobile Layout Tweaks - side margins reduced */
@media (max-width: 640px) {
	.auth-modal-content {
		width: calc(100% - 1em);
		padding-top: calc((100% - 1em) * 0.5625);
		/* 16:9 calc */
	}
}

.close-auth-modal {
	display: block;
	position: absolute;
	left: 0;
	top: -40px;

	text-decoration: none;
	font-size: 20px;
	font-weight: bold;
	color: #fff;
}

.modal-info {
	position: absolute;
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;
	z-index: 1000;

	display: flex;
	justify-content: center;
	align-items: center;

	/* background: #000; */
	/* box-shadow: 0px 2px 16px rgba(0, 0, 0, 0.5); */
}

.modal-info-inner {
	overflow: scroll;
	background: white;
	padding: 4rem 5rem;
	width: 100%;
	height: 100%;
	border-radius: 10px;
	text-align: center;
	box-shadow: 0px 2px 16px rgba(235, 235, 235, 1);
}

.modalInfoEcp {
	display: flex;
	justify-content: center;
	align-items: center;
}

.modal-info-inner h3 {
	font-size: 2rem;
	margin-bottom: 1rem;
}

.auth-moda-explanations {
	margin: 0 0 1rem 0;
}

.auth-choose-cert {
	padding: 1rem 2rem;
	border: none;
	outline: none;
	border-radius: 10px;
	background: #36429e;
	color: white;
	cursor: pointer;
}

/* Show modal by adding class to body */
.show-auth-modal .auth-modal {
	opacity: 1;

	transform: translate(0%, 0%);
	-webkit-transform: translate(0%, 0%);
}

.show-auth-modal .auth-modal .overlay {
	opacity: 1;
}

.show-auth-modal .auth-modal-content {
	transform: translate(0%, 0%);
	-webkit-transform: translate(0%, 0%);
}

/* History table */
.history-container {
	padding-bottom: 5rem;
}

.history-container h2 {
	text-align: center;
	margin-bottom: 0.5rem;
}

.history-table {
	border-collapse: collapse;
	width: 100%;
	height: 100%;
	max-width: 1460px;
	padding: 1rem;
	border: none;
}

.history-table thead {
	background: #f3f5ff;
	height: 70px;
}

.history-table thead th:nth-child(1) {
	border-top-left-radius: 10px;
}

.history-table thead th:nth-child(6) {
	border-top-right-radius: 10px;
}

.history-table th {
	padding: 1rem;
	color: #565656;
}

.history-table tr {
	cursor: pointer;
}

.history-table tr:hover {
	background: #f3f5ff;
}

.history-table td {
	padding: 1rem;
}

.history-table th,
.history-table td {
	border: none;
}

.embed-file {
	width: 80%;
	height: 100%;
	margin: 1.5rem auto;
	max-height: 800px;
	object-fit: contain;
}

/* Status info */
.status-info {
	/* position: absolute;
  right: 30px; */
	display: block;
	/* padding: 1rem 2rem; */
	/* border: 1px solid #7ad38d; */
	border: none;
	outline: none;
	font-size: 1.1rem;
	border-radius: 10px;
	margin: 0 auto;
	background: none;
}

.table-actions-button {
	padding: 1rem 2rem;
	border: none;
	outline: none;
	border-radius: 10px;
	margin-left: 1rem;
	cursor: pointer;
	font-size: 1.1rem;
}

.btn-upload-file {
	background: none;
	margin-left: -1rem;
}

.btn-green {
	background: #7ad38d;
	color: white;
}

.btn-blue {
	background: #36429e;
	color: white;
}

.file-area {
	width: 100%;
	position: relative;
}

.file-area input[type='file'] {
	position: absolute;
	width: 100%;
	height: 100%;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	opacity: 0;
	cursor: pointer;
	border-radius: 25px;
}

.file-area .file-state {
	width: 100%;
	padding: 1rem 1rem;

	border-radius: 10px;
	/* margin-left: 1rem; */
	cursor: pointer;
	font-size: 1.1rem;

	background: #5769f8;
	color: #fff;
	text-align: center;
	transition: background 0.3s ease-in-out;
}

.file-area .file-state .success {
	display: none;
}

.file-area:hover .file-state {
	background: rgba(255, 255, 255, 0.1);
	color: black !important;
}

.link-file {
	background: #36429e;
	padding: .5rem;
	border-radius: 5px;
	color: #fff;
	transition: all .3s;
	border: 1px solid #36429e;
}

.link-file:hover {
	color: #36429e;
	background: none;
	border: 1px solid #36429e;
}

.modalEditRequest {
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
	gap: 1rem;
	height: 100%;
}

.edit-approved-report-modal {
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
	gap: 1rem;
}
</style>
